import { Application } from '@/application/Application'
import Facade from './Facade'
import { configureOperatorConfig, setModulesConfig } from '@dragonframework/modules'
import ModulesConfig from '@/modulesConfig'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { configRepo } from './repository'
import ExternalUiAdapter from './ui/ExternalUiAdapter'
import { mountUi, unmountUi } from '@dragonframework/slot-ui'
import { buildAssetUrl } from '@/utils/AssetsUrlUtil'
import '@/managers/TournamentManager'

dayjs.extend(duration)

declare global {
    interface Window {
        __cashCongBootstrapped?: boolean
    }
}

if (!Facade.isDebug) {
    console.log = function () {
        // empty
    }
}

window.onload = async function () {
    if (window.__cashCongBootstrapped) {
        console.warn('[Bootstrap] Already initialized, skip duplicated startup')
        return
    }

    window.__cashCongBootstrapped = true

    // Set the operator config source here directly, without using a .env file.
    // This is always remote now, even in local/dev.
    const USE_REMOTE_OPERATOR_CONFIG = false
    const REMOTE_OPERATOR_CONFIG_URL = 'https://staging-games.dragongaming.com/games/slots/config/operatorConfig.js'
    const LOCAL_OPERATOR_CONFIG_URL = buildAssetUrl('/assets/js/operatorConfig.js')
    const operatorConfigUrl = USE_REMOTE_OPERATOR_CONFIG ? REMOTE_OPERATOR_CONFIG_URL : LOCAL_OPERATOR_CONFIG_URL

    await configureOperatorConfig(null, operatorConfigUrl)

    // Inject game-specific modules config into the shared framework singleton
    setModulesConfig(ModulesConfig)

    // Initialize PixiJS game
    new Application()

    // External package UI only
    mountUi(document.body)
    const adapter = new ExternalUiAdapter()
    adapter.start()
    ;(window as unknown as { __cashCongExternalUiAdapter?: ExternalUiAdapter }).__cashCongExternalUiAdapter = adapter

    window.addEventListener('beforeunload', () => {
        adapter.stop()
        unmountUi()
    })

    configRepo.getState().load()
}
